export type { DeviceType } from "@pandas/http-client";
export const selfCosmeticComponents = [
	"self-camera-cosmetics",
	"self-back-cosmetics",
	"self-body-frame-cosmetics",
	"self-front-cosmetics",
	"question-body-frame",
	"self-device-skin",
] as const;
export const selfFunctionalComponents = [
	"self-device-turns-on",
	"self-lcd-condition",
	"question-screen-blemishes",
	"self-buttons-work",
] as const;
export const smartwatchComponents = [
	"self-device-turns-on",
	"self-charger",
	"self-device-material",
	"self-overall-condition",
	"self-strap",
] as const;
export const selfComponents = [
	...selfCosmeticComponents,
	...selfFunctionalComponents,
	...smartwatchComponents,
] as const;
export const functionalComponents = [
	"biometrics",
	"front-camera-ai",
	"gyroscope",
	"multitouch",
	"audio",
	"back-camera-ai",
	"digitizer",
] as const;
export const graderComponents = [
	"grader-camera-cosmetics",
	"grader-front-cosmetics",
	"grader-body-frame-cosmetics",
	"grader-lcd-condition",
	"grader-back-cosmetics",
	"grader-device-skin",
] as const;
export type SelfComponent = (typeof selfComponents)[number];
export type SelfCosmeticComponent = (typeof selfCosmeticComponents)[number];
export type GraderCosmeticComponent = (typeof graderComponents)[number];
export type SelfFunctionalComponent = (typeof selfFunctionalComponents)[number];
export type FunctionalComponent = (typeof functionalComponents)[number];
export type SmartwatchComponent = (typeof smartwatchComponents)[number];
export type AssessmentComponent =
	| SelfCosmeticComponent
	| SelfFunctionalComponent
	| FunctionalComponent
	| SmartwatchComponent
	| GraderCosmeticComponent;
